window.initCardSlider ?? (() => {
  window.initCardSlider = (section_id) => {

    const cardSliderSection = document.querySelector(`section#shopify-section-${section_id} .card-slide-section`);
    const showRelevantImage = (currentSlideIndex) => {
        //console.log(currentSlideIndex.toString());  
        cardSliderSection.querySelectorAll('.card-slide-block .card-image').forEach((card_image) => {
          console.log('card_img:'+card_image.dataset.slide);
          if(card_image.dataset.slide == currentSlideIndex.toString()) {
            card_image.classList.add('active'); 
          } else {
           card_image.classList.remove('active'); 
          }
        });
    }

  var swiper = new Swiper(`section#shopify-section-${section_id} .swiper`, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      on: {
        slideChange: function () {
          const currentSlideIndex = this.realIndex;
          showRelevantImage(currentSlideIndex);
        }
      }
  });
  
}
})();